(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/racing/game-engine/assets/javascripts/engines/base/top-rank-pix.js') >= 0) return;  svs.modules.push('/components/racing/game-engine/assets/javascripts/engines/base/top-rank-pix.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

const createTopRankEngine = svs.racing.gameEngine.engines.createEngineTopRank;
const couponValues = svs.racing.common.constants.couponValues;
const engineUtils = svs.racing.gameEngine.utils.engine;
const topRankUtils = svs.racing.gameEngine.utils.topRank;
const immutableUtils = svs.racing.gameEngine.utils.immutable;
const SYSTEM_TYPE = svs.racing.common.constants.systemTypes.TOP_RANK_PIX;
const qpProps = svs.racing.common.constants.quickpickProps;
function createEngine(options) {
  const {
    selectors: topRankSelectors,
    actions: topRankActions,
    reducer: topRankReducer,
    getInitialState: topRankGetInitialState
  } = createTopRankEngine(options);
  const getInitialState = config => {
    if (!config || !config.race || !config.race.participants) {
      throw new Error("Can't initialize engine without a config or race");
    }
    const topRankInitialState = topRankGetInitialState(config);
    return _objectSpread(_objectSpread({}, topRankInitialState), {}, {
      customRow: config.race.participants.map(participant => participant.canceled ? couponValues.CANCELED : undefined),
      singleOnFirstPosition: false,
      isXpertenFetched: false
    });
  };
  const selectors = _objectSpread(_objectSpread({}, topRankSelectors), {}, {
    getCustomRowPositions(state) {
      return topRankUtils.rowToPositions(state.customRow, options.numPositions, () => true);
    },
    getPixCustomBody(state) {
      const positionArr = topRankUtils.rowToPositions(state.customRow, options.numPositions, () => true);
      const picks = [{
        legNumber: 1,
        singleOnFirstPosition: state.singleOnFirstPosition,
        positionedParticipants: new Array(options.numPositions).fill({})
      }];
      for (let i = 0; i < positionArr.length; i++) {
        picks[0].positionedParticipants[i] = {
          position: i + 1,
          participants: positionArr[i] !== undefined ? positionArr[i].map(participant => ({
            participantNumber: participant
          })) : []
        };
      }
      return picks;
    },
    getDisabledRanksAsBoolArray(state, index) {
      const currentValue = state.customRow[index] ? state.row[index] : 0;
      const array = Array(options.numPositions);
      for (let i = 0; i < options.numPositions; i++) {
        array[i] = topRankUtils.rankIsSet(currentValue, i);
      }
      const rankIndex = array.findIndex(position => position);
      const rankArray = rankIndex === -1 ? array : array.map(position => !position);
      return rankArray;
    },
    getDisabledRankIndices(state) {
      return topRankUtils.rowToPositions(state.customRow, options.numPositions, () => true).map(position => position !== undefined);
    },
    getFirstPlaceIsPicked(state, index) {
      return topRankUtils.rankIsSet(state.customRow[index] ? state.customRow[index] : 0, 0);
    },
    isPixPick(state, rankIndex, participantNumber) {
      return selectors.getCustomRowPositions(state).flat().findIndex((participant, i) => participant === participantNumber && rankIndex === i) === -1;
    },
    getSingleOnFirstPosition(state) {
      return state.singleOnFirstPosition;
    },
    isAllPositionsCustomPicked(state) {
      return selectors.getCustomRowPositions(state).every(pos => pos !== undefined);
    },
    isNoPositionsCustomPicked(state) {
      return selectors.getCustomRowPositions(state).every(pos => pos === undefined);
    },
    getSerializableData(state) {
      return _objectSpread(_objectSpread({}, topRankSelectors.getSerializableData(state)), {}, {
        customRow: state.customRow,
        singleOnFirstPosition: state.singleOnFirstPosition,
        isXpertenFetched: state.isXpertenFetched
      });
    },
    isXpertenFetched(state) {
      return state.isXpertenFetched;
    }
  });
  const actions = _objectSpread(_objectSpread({}, topRankActions), {}, {
    clearRow() {
      return {
        type: 'CLEAR_ROW'
      };
    },
    toggleSingleOnFirstPosition() {
      return {
        type: 'TOGGLE_SINGLE_ON_FIRST_POSITION'
      };
    },
    setIsXpertenFetched(bool) {
      return {
        type: 'SET_IS_XPERTEN_FETCHED',
        isXpertenFetched: bool
      };
    }
  });
  const reducer = (state, action) => {
    switch (action.type) {
      case 'INITIALIZE':
        {
          return getInitialState({
            race: action.race
          });
        }
      case 'TRY_SET_DATA':
        {
          const maxValue = 2 ** options.numPositions;
          const validationFn = (value, newValue) => {
            if (newValue <= 0 || newValue >= maxValue) {
              return false;
            }
            return true;
          };
          const qpValue = action.data.qpValue ? action.data.qpValue : qpProps.NOQP;
          const parsed = engineUtils.parseData(state.row, action.data, false, validationFn);
          const customRow = action.data.customRow || state.customRow;
          const allPositionsCustomPicks = selectors.isAllPositionsCustomPicked({
            customRow
          });
          if (allPositionsCustomPicks) {
            options.xpert.data[0].disabled = true;
          } else {
            options.xpert.data[0].disabled = false;
          }
          return _objectSpread(_objectSpread({}, state), {}, {
            row: parsed.row,
            error: parsed.error,
            reserve: parsed.reserve,
            qpValue,
            pixSize: action.data.pixSize || 0,
            customRow,
            singleOnFirstPosition: action.data.singleOnFirstPosition || state.singleOnFirstPosition,
            isXpertenFetched: action.data.isXpertenFetched || state.isXpertenFetched
          });
        }
      case 'TOGGLE_INDEX_RANK':
        {
          if (action.index > state.row.length - 1 || action.index < 0) {
            return state;
          }
          if (action.rank > options.numPositions - 1 || action.rank < 0) {
            return state;
          }
          const currentValue = state.row[action.index];
          if (!engineUtils.isAvailable(currentValue)) {
            return state;
          }
          let newValue = topRankUtils.toggleRank(currentValue, action.rank);

          newValue = newValue > 0 ? newValue : undefined;
          const row = immutableUtils.updateArrayIndex(state.row, action.index, () => newValue);
          let {
            customRow,
            singleOnFirstPosition
          } = state;

          if (!selectors.isXpertenFetched(state)) {
            if (!currentValue || currentValue && state.customRow[action.index] === currentValue) {
              customRow = immutableUtils.updateArrayIndex(state.customRow, action.index, () => newValue);
              if (action.index === 0 && action.rank === 0 && currentValue === 1) {
                singleOnFirstPosition = false;
              }
            }
          }
          const allPositionsCustomPicks = selectors.isAllPositionsCustomPicked({
            customRow
          });
          if (allPositionsCustomPicks) {
            options.xpert.data[0].disabled = true;
          } else {
            options.xpert.data[0].disabled = false;
          }
          const qpValue = state.qpValue === qpProps.PARTIALQP || state.qpValue === qpProps.MODIFIEDQP ? qpProps.MODIFIEDQP : qpProps.NOQP;
          let currentReserve = state.reserve;
          if (currentReserve && currentReserve >= 0 && engineUtils.isPosition(row[currentReserve]) && topRankUtils.getUniqueRows(row, options.numPositions).length === 1) {
            currentReserve = undefined;
          }
          return _objectSpread(_objectSpread({}, state), {}, {
            reserve: currentReserve,
            row,
            qpValue,
            customRow,
            singleOnFirstPosition,
            allPositionsCustomPicks
          });
        }
      case 'CLEAR_ALL':
        options.xpert.data[0].disabled = false;
        return _objectSpread(_objectSpread({}, state), {}, {
          row: state.row.map(value => value === couponValues.CANCELED ? couponValues.CANCELED : undefined),
          customRow: state.row.map(value => value === couponValues.CANCELED ? couponValues.CANCELED : undefined),
          reserve: undefined,
          qpValue: qpProps.NOQP,
          pixSize: 0,
          singleOnFirstPosition: false,
          isXpertenFetched: false
        });
      case 'CLEAR_ROW':
        return _objectSpread(_objectSpread({}, state), {}, {
          row: state.row.map(value => value === couponValues.CANCELED ? couponValues.CANCELED : undefined),
          reserve: undefined,
          qpValue: qpProps.NOQP,
          pixSize: 0
        });
      case 'TOGGLE_SINGLE_ON_FIRST_POSITION':
        return _objectSpread(_objectSpread({}, state), {}, {
          singleOnFirstPosition: !state.singleOnFirstPosition
        });
      case 'SET_IS_XPERTEN_FETCHED':
        return _objectSpread(_objectSpread({}, state), {}, {
          isXpertenFetched: action.isXpertenFetched
        });
      default:
        return topRankReducer(state, action);
    }
  };
  return _objectSpread(_objectSpread({}, options), {}, {
    systemType: SYSTEM_TYPE,
    getInitialState,
    selectors,
    actions,
    reducer
  });
}
svs.racing.gameEngine.engines.createEngineTopRankPix = createEngine;

 })(window);